import { EventName, TrackingType } from "./types";

export const tracking: TrackingType = {
	registerCurrentMerchantAndTenant: (merchantId, tenantId, userEmail, userId) => {
		window.adobeDataLayer.push({
			merchant_id: merchantId,
			tenant_id: tenantId,
			email: userEmail,
			user_id: userId,
		});
	},
	registerCurrentMerchantName: (merchantName) => {
		window.adobeDataLayer.push({
			merchant_name: merchantName,
		});
	},
	registerCurrentMerchantUserCount: (userCount) => {
		window.adobeDataLayer.push({
			userCount,
		});
	},
	registerPage: (page) => {
		// We need to avoid sending the default page values to the Adobe DataLayer
		if (
			page !== `Bread Pay® Merchant Portal` &&
			page !== `Bread Pay® Preview Merchant Portal`
		) {
			window.adobeDataLayer.push({
				event: "pageLoaded",
				page: {
					title: page,
				},
			});
		}
	},
	trackDateRangerPickerClick: () => {
		window.adobeDataLayer.push({
			event: EventName.DateRangerPickerClick,
		});
	},
	trackDateRangeStaticSelection: (staticRange) => {
		window.adobeDataLayer.push({
			event: EventName.DateRangeStaticSelection,
			eventInfo: {
				staticRange,
			},
		});
	},
	trackDateRangeSelection: (daysSelected) => {
		window.adobeDataLayer.push({
			event: EventName.DateRangeSelection,
			eventInfo: {
				daysSelected,
			},
		});
	},
	trackStatusFilterSelection: (activeStatuses) => {
		window.adobeDataLayer.push({
			event: EventName.StatusFilterSelection,
			eventInfo: {
				activeStatuses,
			},
		});
	},
	trackPaymentProductFilterSelection: (activeProductTypes) => {
		window.adobeDataLayer.push({
			event: EventName.PaymentProductFilterSelection,
			eventInfo: {
				activeProductTypes,
			},
		});
	},
	trackCartsFilterSelection: (activeCartTypes) => {
		window.adobeDataLayer.push({
			event: EventName.CartsFilterSelection,
			eventInfo: {
				activeCartTypes,
			},
		});
	},
	trackSearchTypeSelection: (activeSearchType) => {
		window.adobeDataLayer.push({
			event: EventName.SearchTypeSelection,
			eventInfo: {
				activeSearchType,
			},
		});
	},
	trackSearchRan: (searchType) => {
		window.adobeDataLayer.push({
			event: EventName.SearchRan,
			eventInfo: {
				searchType,
			},
		});
	},
	trackHelpClick: () => {
		window.adobeDataLayer.push({
			event: EventName.HelpClick,
		});
	},
	trackLegalDocumentClick: (documentName) => {
		window.adobeDataLayer.push({
			event: EventName.LegalDocumentClick,
			eventInfo: {
				documentName,
			},
		});
	},
	trackTransactionsViewPageChange: (page) => {
		window.adobeDataLayer.push({
			event: EventName.TransactionsViewPageChange,
			eventInfo: {
				page,
			},
		});
	},
	trackKPIClick: (status) => {
		window.adobeDataLayer.push({
			event: EventName.KpiClick,
			eventInfo: {
				status,
			},
		});
	},
	trackUserManagementClick: () => {
		window.adobeDataLayer.push({
			event: EventName.UserManagementClick,
		});
	},
	trackAccountSettingsClick: () => {
		window.adobeDataLayer.push({
			event: EventName.AccountSettingsClick,
		});
	},
	trackHelpAndLegalClick: () => {
		window.adobeDataLayer.push({
			event: EventName.HelpAndLegalClick,
		});
	},
	trackNotificationAlertsClick: () => {
		window.adobeDataLayer.push({
			event: EventName.NotificationAlertsClick,
		});
	},
	trackUserNameClick: () => {
		window.adobeDataLayer.push({
			event: EventName.UserNameClick,
		});
	},
	trackLoginSuccess: () => {
		window.adobeDataLayer.push({
			event: EventName.LoginSuccess,
		});
	},
	trackLogoutClick: () => {
		window.adobeDataLayer.push({
			event: EventName.LogoutClick,
		});
	},
	trackLogoutInactivity: () => {
		window.adobeDataLayer.push({
			event: EventName.LogoutInactivity,
		});
	},
	trackAddNewUser: () => {
		window.adobeDataLayer.push({
			event: EventName.AddNewUser,
		});
	},
	trackRemoveUser: () => {
		window.adobeDataLayer.push({
			event: EventName.RemoveUser,
		});
	},
	trackUpdateUserRole: (role) => {
		window.adobeDataLayer.push({
			event: EventName.UpdateUserRole,
			eventInfo: {
				role,
			},
		});
	},
	trackPrimaryNavigationClick: (subNavLocation) => {
		window.adobeDataLayer.push({
			event: EventName.PrimaryNavigationClick,
			eventInfo: {
				subNavLocation,
			},
		});
	},
	trackTransactionIDCopy: () => {
		window.adobeDataLayer.push({
			event: EventName.TransactionIdCopy,
		});
	},
	trackClickTransactionAction: (selectedAction) => {
		window.adobeDataLayer.push({
			event: EventName.ClickTransactionAction,
			...(selectedAction && {
				eventInfo: {
					selectedAction,
				},
			}),
		});
	},
	trackDataInsightCardClick: (selectedDataInsightCard) => {
		window.adobeDataLayer.push({
			event: EventName.DataInsightCardClick,
			eventInfo: {
				selectedDataInsightCard,
			},
		});
	},
	trackDataInsightDateOptionClick: (selectedDataInsightDateOption) => {
		window.adobeDataLayer.push({
			event: EventName.DataInsightDateOptionClick,
			eventInfo: {
				selectedDataInsightDateOption,
			},
		});
	},
	trackClickTransactionDetailTab: (tab) => {
		window.adobeDataLayer.push({
			event: EventName.ClickTransactionDetailTab,
			eventInfo: {
				tab,
			},
		});
	},
	trackOpenTooltip: () => {
		window.adobeDataLayer.push({
			event: EventName.OpenTooltip,
		});
	},
	trackCSVFileDownload: () => {
		window.adobeDataLayer.push({
			event: EventName.CsvFileDownload,
		});
	},
	trackAccountSettingsUpdate: (updatedSettings) => {
		window.adobeDataLayer.push({
			event: EventName.AccountSettingsUpdate,
			eventInfo: {
				updatedSettings,
			},
		});
	},
	trackUnsavedChangesNavigation: () => {
		window.adobeDataLayer.push({
			event: EventName.UnsavedChangesNavigation,
		});
	},
	trackDiscardAccountSettingsChanges: () => {
		window.adobeDataLayer.push({
			event: EventName.DiscardAccountSettingsChanges,
		});
	},
	trackAddEmailNotification: (programID, notificationTypes) => {
		window.adobeDataLayer.push({
			event: EventName.AddEmailNotification,
			eventInfo: {
				programID,
				notificationTypes,
			},
		});
	},
	trackDeleteEmailNotification: (programID) => {
		window.adobeDataLayer.push({
			event: EventName.DeleteEmailNotification,
			eventInfo: {
				programID,
			},
		});
	},
	trackUpdateEmailNotification: (programID, notificationTypes) => {
		window.adobeDataLayer.push({
			event: EventName.UpdateEmailNotification,
			eventInfo: {
				programID,
				notificationTypes,
			},
		});
	},
	trackAccessKeyCopied: (accessKeyType) => {
		window.adobeDataLayer.push({
			event: EventName.AccessKeyCopied,
			eventInfo: {
				accessKeyType,
			},
		});
	},
	trackMerchantIdCopied: () => {
		window.adobeDataLayer.push({
			event: EventName.MerchantIdCopied,
		});
	},
	trackNotificationLinkClick: (notificationType) => {
		window.adobeDataLayer.push({
			event: EventName.NotificationLinkClick,
			eventInfo: {
				notificationType,
			},
		});
	},
	trackCreateCartClick: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartClick,
		});
	},
	trackViewCartClick: () => {
		window.adobeDataLayer.push({
			event: EventName.ViewCartClick,
		});
	},
	trackExpireCart: () => {
		window.adobeDataLayer.push({
			event: EventName.ExpireCart,
		});
	},
	trackResendCartEmail: () => {
		window.adobeDataLayer.push({
			event: EventName.ResendCartEmail,
		});
	},
	trackCartLinkCopy: () => {
		window.adobeDataLayer.push({
			event: EventName.CartLinkCopy,
		});
	},
	trackCreateCartEnterCartTotal: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartEnterCartTotal,
		});
	},
	trackCreateCartAddItemsToCart: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartAddItemsToCart,
		});
	},
	trackCreateCartAddOrderItem: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartAddOrderItem,
		});
	},
	trackCreateCartEditOrderItem: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartEditOrderItem,
		});
	},
	trackCreateCartRemoveOrderItem: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartRemoveOrderItem,
		});
	},
	trackCreateCartSaveCart: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartSaveCart,
		});
	},
	trackEditCartSaveChanges: () => {
		window.adobeDataLayer.push({
			event: EventName.EditCartSaveChanges,
		});
	},
	trackEditCartDiscardChanges: () => {
		window.adobeDataLayer.push({
			event: EventName.EditCartDiscardChanges,
		});
	},
	trackViewCartGoBackToCartsList: () => {
		window.adobeDataLayer.push({
			event: EventName.ViewCartGoBackToCartsList,
		});
	},
	trackCreateCartDiscardCart: () => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartDiscardCart,
		});
	},
	trackCreateCartAccordionAction: (section) => {
		window.adobeDataLayer.push({
			event: EventName.CreateCartAccordionAction,
			eventInfo: {
				section,
			},
		});
	},
	trackTransactionListExportClick: () => {
		window.adobeDataLayer.push({
			event: EventName.TransactionListExportIconClick,
		});
	},
	trackMerchantPlacementThemeSelection: (theme) => {
		window.adobeDataLayer.push({
			event: EventName.MerchantPlacementThemeSelection,
			eventInfo: {
				theme,
			},
		});
	},
	trackGeneratingLocationVerificationCodes: () => {
		window.adobeDataLayer.push({
			event: EventName.GeneratingLocationVerificationCodes,
		});
	},
	trackLocationVerificationCodeCopy: () => {
		window.adobeDataLayer.push({
			event: EventName.LocationVerificationCodeCopy,
		});
	},
};
